import { createEntityAdapter, createSlice, EntityState, PayloadAction } from "@reduxjs/toolkit";
import merge from 'lodash/merge';
import { isEqual, keyBy } from "lodash";

import { FeedComponentInfo } from "../GQLCalls/getFeedComponentsCall";
import Graph_QL, { DynamicDataObk } from "../..";


export type FeedComponentItem = DynamicDataObk<FeedComponentInfo[]>

const feedComponentsDataAdapter = createEntityAdapter({
  selectId: (item: FeedComponentItem) => Graph_QL.ObjToString(item.con)
});

const mergePayloadAndState = (state: EntityState<FeedComponentItem, string>, {con, data}: FeedComponentItem) => {
  const identifier = Graph_QL.ObjToString(con);
  if (state.entities[identifier]) {
    const existingData = state.entities[identifier].data;
    const mergedData = Object.values(merge(keyBy(state.entities[identifier].data, "id"), keyBy(data, "id")));
    const newPayload = {con, data: mergedData}
    if (newPayload.data.length !== existingData.length || !isEqual(existingData, newPayload.data) ) {
      feedComponentsDataAdapter.upsertOne(state, newPayload);
    }
  } else { feedComponentsDataAdapter.addOne(state, {con, data})}
}

const feedComponentsSlice = createSlice({
  name: "feedComponents",
    initialState: feedComponentsDataAdapter.getInitialState(),
      reducers: {
        maintained: (state, {payload}:PayloadAction<FeedComponentItem>) => {
          mergePayloadAndState(state, payload);
        },
        add: (state, {payload}:PayloadAction<FeedComponentItem>) => {
          mergePayloadAndState(state, payload);
        },
    }
})

export const FeedComponentsActions = feedComponentsSlice.actions;
export default feedComponentsSlice.reducer;